import { render } from "./MaxChangeSettings.vue?vue&type=template&id=391882ee&scoped=true"
import script from "./MaxChangeSettings.vue?vue&type=script&lang=js"
export * from "./MaxChangeSettings.vue?vue&type=script&lang=js"

import "./MaxChangeSettings.vue?vue&type=style&index=0&id=391882ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-391882ee"

export default script